<app-header></app-header>

<section id="equipo-int" class="bg-light reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

          <div class="row" >
             <div class="col-lg-12 mb-4">
                   <h1 class="fw-bold">POLÍTICA DE PROTECCIÓN DE DATOS</h1>
                 
             </div>   
         </div>


          <div class="row" >
             <div class="col-lg-12 mb-5">
                  
                  <p>La presente web tiene carácter meramente informativo y no se recaban datos personales. En el supuesto de que en algún microsite de la web se soliciten datos personales para alguna finalidad y/o servicio concreto o usted los facilite para efectuar una consulta a través de correo electrónico, el tratamiento de sus datos se regirá de acuerdo con los siguientes términos.</p>
                
             </div>   
         </div>


          <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>Información Básica sobre Protección de Datos</h2>
                  <div class="table-responsive"> 
                           
                            <table class="table table-striped">
                               
                                  <tbody>
                                          <tr>
                                             <td>Responsable del tratamiento</td>
                                             <td>RetailCompany 2021, S.L.</td>
                                           
                                          </tr>

                                           <tr>
                                             <td>Dirección postal</td>
                                             <td>Calle Quintanavides Nº13, P.E. Vía Norte, Edif.1 Pl.4, 28050 Madrid</td>
                                           
                                          </tr>

                                           <tr>
                                             <td>Contacto del Encargado de Protección de Datos</td>
                                             <td><a href="mailto:privacidad1@retailco.es">privacidad1@retailco.es</a></td>
                                           
                                          </tr>
                                              

                                          <tr>
                                             <td>Finalidades y Legitimación</td>
                                             <td>Gestión de los servicios concretos solicitados por parte del interesado o cumplimiento de obligaciones legales. </td>
                                           
                                          </tr>
                                              

                                          <tr>
                                             <td>Destinatarios</td>
                                             <td>Sus datos no serán cedidos a terceros destinatarios.</td>
                                           
                                          </tr>
                                              

                                          <tr>
                                             <td>Derechos</td>
                                             <td>El interesado podrá en todo momento ejercitar los derechos de oposición, acceso, portabilidad, rectificación, limitación y supresión de datos. </td>
                                           
                                          </tr>
                                              

                                          <tr>
                                             <td>Información adicional</td>
                                             <td>Incluimos el detalle de la información que se incluye en esta tabla debajo de la misma.</td>
                                           
                                          </tr>
                                              
                                              
                                 </tbody>
                            </table>
                     </div>
                
             </div>   
         </div>



          <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>Información adicional sobre Protección de Datos</h2>
                  <p>Retailcompany 2021, S.L., (en adelante “RetailCo”) cumple íntegramente con la normativa en materia de protección de datos de carácter personal y, en particular, con el REGLAMENTO (UE) 2016/679 DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE y con la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, de modo que el tratamiento de la información personal que, en su caso facilitara el interesado, (en adelante, el “interesado”) al solicitar algún servicio concreto para el que nos entregara sus datos a través de cualquier microsite de la web <a href="https://www.retailco.es">www.retailco.es</a> (en adelante, el “Sitio Web”) , se llevará a cabo cumpliendo con las garantías y obligaciones legales exigibles.</p>
                
             </div>   
         </div>

           <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Quién es el responsable del tratamiento de sus datos?</h2>
                  <p>El interesado queda informado de que el responsable del tratamiento de sus datos personales es RetailCo con domicilio en Quintanavides Nº13, P.E. Vía Norte, Edif.1 Pl.4, 28050 Madrid.</p>
                  <p>El Encargado de Protección de Datos es la figura encargada de hacer efectivo el cumplimiento del GDPR a fin de garantizar la protección de los datos personales facilitados por el interesado a través del Sitio Web.</p>
                  <p>Para contactar con el Encargado de Protección de Datos, el interesado puede remitir una comunicación a la siguiente dirección de correo electrónico: <a href="mailto:info@retailco.es">info@retailco.es</a>.</p>
                
             </div>   
         </div>

          <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Por qué y para qué tratamos sus datos personales?</h2>
                  <p>A continuación, se detallan las distintas finalidades de tratamiento que se llevarán cabo por parte de RetailCo:</p>
                  <ul>
                    <li>Gestión de la solicitud, en su caso, del servicio concreto realizada por el interesado a través de un microsite de la web o de correo electrónico.</li>
                    <li>Cumplimiento de obligaciones legales.</li>
                  </ul>  
              
                
             </div>   
         </div>

           <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Durante cuánto tiempo conservaremos sus datos?</h2>
                  <p>Trataremos los datos personales del interesado mientras sean necesarios para la finalidad para la cual fueron recabados.</p>
                  <p>RetailCo bloqueará sus datos y solo los tratará para su puesta a disposición a las Administraciones Públicas competentes, Jueces y Tribunales o el Ministerio Fiscal, para la atención de las posibles responsabilidades relacionadas con el tratamiento de los datos, en particular para el ejercicio y defensa de reclamaciones ante la Agencia Española de Protección de Datos. Conservaremos sus datos bloqueados durante los plazos previstos en las disposiciones aplicables o, en su caso, en las relaciones contractuales mantenidas con RetailCo, procediendo a la supresión física de sus datos una vez transcurridos dichos plazos.</p>
              
                
             </div>   
         </div>


            <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Quiénes recibirán sus datos?</h2>
                  <p>En cuanto respecta a la comunicación de los datos, se informa expresamente que la información personal del interesado no será comunicada a terceros destinatarios, ni tampoco será objeto de transferencias internacionales a terceros países u organizaciones internacionales.</p>
              
                
             </div>   
         </div>


            <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Cuáles son sus derechos cuando nos facilita sus datos?</h2>
                  <p>El interesado podrá ejercer sus derechos de acceso, portabilidad, rectificación, supresión, limitación, oposición, y a no ser objeto de una decisión basada únicamente en el tratamiento automatizado. Asimismo, podrá revocar en cualquier momento el consentimiento prestado.</p>
                  <p>ElPara ejercer los referidos derechos, deberá enviar un correo electrónico a <a href="mailto:info@retailco.es">info@retailco.es</a> o dirigirse por correo postal a C/ Quintanavides Nº13, P.E. Vía Norte, Edif.1 Pl.4, 28050 Madrid, aportando en todo caso copia de su DNI o de documento oficial que le identifique.</p>
              
                
             </div>   
         </div>

          <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>¿Ante quién puede ejercitar sus reclamaciones relacionadas con protección de datos?</h2>
                  <p>El interesado podrá dirigirse al Delegado de Protección de Datos, así como presentar una reclamación ante la Agencia Española de Protección de Datos, si está en desacuerdo con la respuesta que haya recibido. Dispone de la información necesaria en su web: <a href="https://www.aepd.es/es">www.aepd.es</a>.</p>
              
                
             </div>   
         </div>






     </div><!-- fin container-->

</section>


<app-footer-main></app-footer-main>